import React, { useCallback } from "react";
import {
  FormControlLabel,
  Grid,
  makeStyles,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import ReportsCard from "./ReportsCard";
import { append, equals, includes, reject } from "ramda";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 10,
  },

  cardForm: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20,
  },
}));

const ContentTypeCard = ({ reportType, state, handleStateChange }) => {
  const classes = useStyles();

  const handleContentTypeSelected = useCallback(
    event => {
      const value = event.target.name;
      const isChecked = event.target.checked;

      const updated = isChecked
        ? append(value, state.contentTypes)
        : reject(equals(value), state.contentTypes);

      console.log(updated);

      handleStateChange("contentTypes")(updated);
    },
    [state.contentTypes, handleStateChange]
  );

  return (
    <ReportsCard
      classes={{ root: classes.root }}
      cardLabel={`You can limit the ${reportType} records to only particular content types by selecting one or more of the next checkboxes. No selection means that all content types will be taken into account.`}
    >
      <Grid container spacing={2} classes={{ root: classes.cardForm }}>
        <Grid item xs={12}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("book", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="book"
                />
              }
              label="Books"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("image", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="image"
                />
              }
              label="Images"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("article", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="article"
                />
              }
              label="Articles"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("video", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="video"
                />
              }
              label="Videos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("audio", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="audio"
                />
              }
              label="Audio"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includes("other_document", state.contentTypes)}
                  onChange={handleContentTypeSelected}
                  name="other_document"
                />
              }
              label="Other Documents"
            />
          </FormGroup>
        </Grid>
      </Grid>
    </ReportsCard>
  );
};

export default ContentTypeCard;
